/* unplugin-vue-components disabled */import script from "./ChannelList.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChannelList.vue?vue&type=script&setup=true&lang=ts"

import "./ChannelList.vue?vue&type=style&index=0&id=0a5ebd3d&lang=less"

const __exports__ = script;

export default __exports__